import React from "react";
import { Sparkles, Heart } from "lucide-react";

/**
 * Permanent CTA to the Solfut relational coaching service.
 * Used in Navbar (desktop) and as a footer card on auth pages.
 */
const CoachingLink = ({ url, variant = "nav" }) => {
  const safeUrl = url || "https://ihavethepower.net/loja/coaching/life-coaching-com-coach-ihtp/";

  if (variant === "footer") {
    return (
      <a href={safeUrl} target="_blank" rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-xs text-[#A29F9B] hover:text-[#C5A880] transition-colors"
        data-testid="coaching-footer-link">
        <Heart className="w-3 h-3" />
        Coaching Solfut
      </a>
    );
  }
  return (
    <a href={safeUrl} target="_blank" rel="noopener noreferrer"
      className="hidden md:inline-flex items-center gap-1.5 text-xs text-[#A29F9B] hover:text-[#C5A880] transition-colors"
      title="Coaching de Relacionamentos Solfut"
      data-testid="coaching-nav-link">
      <Sparkles className="w-3.5 h-3.5" />
      Coaching
    </a>
  );
};

export default CoachingLink;
